import { takeLatest, call, put, all } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import * as SnackbarAction from '../actions/snackbarAction';
import * as InvoiceVendorAction from '../actions/invoiceVendorAction';
import history from '../utils/history';

function* createVendor(action) {
  try {
    let submitResponse = null;
    const response = yield call(
      callApi,
      URLS.CREATE_VENDOR,
      'POST',
      action.payload,
      true,
    );
    if (action.isSubmit && response?.res_data?.vendor?.vendor_id) {
      submitResponse = yield call(callApi, URLS.SUBMIT_VENDOR, 'POST', {
        vendor_id: response?.res_data?.vendor?.vendor_id,
      });
    }

    yield put(
      SnackbarAction.openSnackbar({
        message: submitResponse ? submitResponse.res_str : response.res_str,
        type: 'success',
      }),
    );
    history.push(`/vendor/myvendor?tab=${action.isSubmit ? 'All' : 'Saved'}`);
    yield put(InvoiceVendorAction.setVendorDetails({}));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
function* getGstinDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.GET_GSTIN_DATA,
      'get',
      action.payload,
    );
    yield put(InvoiceVendorAction.setGstinDetails(response.res_data));
  } catch (error) {
    yield put(InvoiceVendorAction.setGstinDetails({}, true));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: error.data.res_str,
    //     type: 'error',
    //   }),
    // );
  }
}
function* getVendorDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.CREATE_VENDOR,
      'GET',
      action.payload,
    );
    yield put(InvoiceVendorAction.setVendorDetails(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
function* getCityState(action) {
  try {
    const response = yield call(
      callApi,
      URLS.CITY_TYPEAHEAD,
      'GET',
      action.data,
    );
    yield put(InvoiceVendorAction.setCityState(response.res_data));
  } catch (error) {
    yield put(InvoiceVendorAction.setCityState(''));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: error.data.res_str,
    //     type: 'error',
    //   }),
    // );
  }
}
function* getWorkflowDetails(action) {
  try {
    const { id, url, params } = action.payload;
    const apiUrl = Object.keys(params).length
      ? URLS[url]
      : `${URLS[url]}${id}/`;
    const workflowResponse = yield call(callApi, `${apiUrl}`, 'get', params);
    const stateSettingResponse = yield call(
      callApi,
      `${URLS.STATE_SETTING}${workflowResponse.res_data.current_state?.state_setting_id}/`,
      'get',
      {},
    );
    yield put(
      InvoiceVendorAction.setVendorDetails({
        ...workflowResponse.res_data,
        stateSetting: stateSettingResponse.res_data,
      }),
    );
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
function* workflowContainerAction(action) {
  try {
    const response = yield call(
      callApi,
      URLS.WORKFLOW_ACTION,
      'POST',
      action.payload,
    );
    yield put(InvoiceVendorAction.setVendorDetails(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
function* workflowContainerCommentAction(action) {
  try {
    const [workflowres] = yield all([
      call(callApi, URLS.WORKFLOW_ACTION, 'POST', action.containerData),
      action.commentData &&
        call(callApi, URLS.WORKFLOW_COMMENTS, 'POST', action.commentData),
    ]);

    history.push('/vendor/myapproval?tab=Pending');
    yield put(
      SnackbarAction.openSnackbar({
        message: workflowres.res_str,
        type: 'success',
      }),
    );
    // yield put(InvoiceVendorAction.setVendorDetails(response.res_data));
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}

function* updateVendorDetails(action) {
  try {
    const response = yield call(
      callApi,
      URLS.VENDOR_UPDATE,
      'POST',
      action.payload,
      true,
    );
    if (action.isSubmit && response?.res_data?.vendor?.vendor_id) {
      yield call(callApi, URLS.SUBMIT_VENDOR, 'POST', {
        vendor_id: response?.res_data?.vendor?.vendor_id,
      });
    }
    yield put(
      SnackbarAction.openSnackbar({
        message: response?.res_str || '',
        type: 'success',
      }),
    );
    yield put(InvoiceVendorAction.setVendorDetails({}));
    history.push(`/vendor/myvendor?tab=${action.isSubmit ? 'All' : 'Saved'}`);
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error?.data?.res_str || '',
        type: 'error',
      }),
    );
  }
}
function* getBankDetailsThroughIfsc(action) {
  try {
    const response = yield call(
      callApi,
      URLS.IFSC_BANK_DETAILS,
      'GET',
      action.payload,
    );
    yield put(InvoiceVendorAction.setBankDetailsThroughIfsc(response.res_data));
  } catch (error) {
    yield put(InvoiceVendorAction.setBankDetailsThroughIfsc({error: error.data.res_str}));
    // yield put(
    //   SnackbarAction.openSnackbar({
    //     message: error.data.res_str,
    //     type: 'error',
    //   }),
    // );
  }
}
export function* submitVendor(action) {
  try {
    const res = yield call(callApi, URLS.SUBMIT_VENDOR, 'POST', action.payload);
    yield put(
      SnackbarAction.openSnackbar({
        message: res.res_str,
        type: 'success',
      }),
    );
    history.push('/vendor/myvendor?tab=All');
  } catch (error) {
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
export function* getChequeDetails(action) {
  try {
    const res = yield call(
      callApi,
      URLS.CHEQUE_INFO,
      'POST',
      action.payload,
      true,
    );
    yield put(
      SnackbarAction.openSnackbar({
        message: res.res_str,
        type: 'success',
      }),
    );
    yield put(InvoiceVendorAction.setChequeDetails(res.res_data));
  } catch (error) {
    if(action.shimmerCallBack){
      yield put(action.shimmerCallBack);
    }
    yield put(
      SnackbarAction.openSnackbar({
        message: error.data.res_str,
        type: 'error',
      }),
    );
  }
}
export function* vendorSaga() {
  yield takeLatest('SAVE_VENDOR_DETAILS', createVendor);
  yield takeLatest('GET_GSTIN_DETAILS', getGstinDetails);
  yield takeLatest('EDIT_VENDOR_DETAILS', getVendorDetails);
  yield takeLatest('GET_CITY_STATE', getCityState);
  yield takeLatest('GET_VENDOR_WORKFLOW', getWorkflowDetails);
  yield takeLatest('UPDATE_VENDOR', updateVendorDetails);
  yield takeLatest('WORKFLOW_VENDOR_CONTAINER_ACTION', workflowContainerAction);
  yield takeLatest(
    'WORKFLOW_VENDOR_CONTAINER_COMMENT_ACTION',
    workflowContainerCommentAction,
  );
  yield takeLatest('GET_IFSC_BANK_DETAILS', getBankDetailsThroughIfsc);
  yield takeLatest('SUBMIT_VENDOR', submitVendor);
  yield takeLatest('GET_CHEQUE_DETAILS', getChequeDetails);
}
